export default (props, vars) =>
  vars?.['useapplicationsstatus2']?.['applicationStatus'].filter(
    (app) => app.isPaused
  ).length > 0;
